<template>
	<div class="bg-[#F6F8FA]">
		<Header :current="0"></Header>
		<div class="2xl:max-w-7xl xl:max-w-7xl mx-auto mb-[100px] py-[16px]  box-border">
			<div class="flex items-center text-[18px] mb-[27px]">
				<label class="cursor-pointer mr-[5px]" @click="goIndex()">{{langInfo.head_home_nav}}</label>><label
					class="cursor-pointer mr-[5px] ml-[5px]"
					@click="goResourceDownload()">{{langInfo.head_download_nav}}</label>><label
					class="w-[150px] text-[#adadad] yw-text-cut-1 ml-[5px]">
					{{newDetail.title}}
				</label>
			</div>
			<div class="pb-[19px] box-border bB-01">
				<div class="text-[36px] text-[#101010] text-center font-bold mb-[20px]">
					{{newDetail.title}}
				</div>
				<!-- is_l1 点赞    is_l2 收藏-->
				<div class="flex items-center justify-center">
					<img src="@/static/image/icon61.png" class="w-[20px] h-[20px] mr-[4px]" alt="" />
					<label class="text-[13px] mr-[17px] text-[#686C73]">{{newDetail.create_time}}</label>
					<img src="@/static/image/icon62.png" class="w-[20px] h-[20px] mr-[4px]" alt="" />
					<label
						class="text-[13px] mr-[10px] text-[#686C73]">{{newDetail.number_views}}/{{langInfo.time}}</label>
					<div class="flex items-center cursor-pointer" @click="newsResourceLikeClick(2)">
						<img :src="newDetail.is_l2==1?collectActive:collectImg"
							class="w-[20px] h-[20px] mr-[4px] cursor-pointer" alt="" />
						<label
							class="text-[13px] mr-[16px] text-[#686C73] cursor-pointer">{{newDetail.is_l2==1?langInfo.collected:langInfo.new_collect}}</label>
					</div>
					<div class="flex items-center cursor-pointer" @click="newsResourceLikeClick(1)">
						<img :src="newDetail.is_l1==1?zanActive:zanImg"
							class="w-[18px] h-[18px] mr-[4px] cursor-pointer" alt="" />
						<label
							class="text-[13px] mr-[16px] text-[#686C73] cursor-pointer">{{newDetail.number_likes}}</label>
					</div>
					<el-popover placement="bottom" trigger="hover">
						<div class="">
							<div @click="shareQQ()" class="cursor-pointer flex items-center pb-[10px] box-border bB-04">
								<img src="@/static/image/icon78.png" class="w-[20px] h-[20px] mr-[10px]" alt=""
									srcset="" /> {{langInfo['Share_QQ']}}
							</div>
							<div @click="shareWB()"
								class="cursor-pointer flex items-center pt-[10px] pb-[10px] box-border bB-04">
								<img src="@/static/image/icon79.png" class="w-[20px] h-[20px] mr-[10px]" alt=""
									srcset="" />
								{{langInfo['Share_Weibo']}}
							</div>
							<div @click="shareWx()" class="cursor-pointer flex items-center pt-[10px] box-border">
								<img src="@/static/image/icon81.png" class="w-[20px] h-[20px] mr-[10px]" alt=""
									srcset="" />
								{{langInfo['Share WeChat']}}
							</div>
						</div>
						<div slot="reference" class="flex items-center cursor-pointer text-[#101010] text-[16px]">
							<img src="@/static/image/icon63.png" class="w-[20px] h-[20px] cursor-pointer mr-[4px]"
								alt="" />
							<label class="text-[13px] text-[#686C73] cursor-pointer">{{langInfo.share}}</label>
						</div>
					</el-popover>
				</div>
			</div>
			<div class="py-[20px] box-border mb-[30px]">
				<div class="" v-html="newDetail.content">
				</div>
			</div>
			<div class="flex items-center mb-[20px] pl-[20px] pb-[16px] box-border bB-03">
				<div class="navTitle   active text-[#FF0000]  relative text-[20px]">
					{{langInfo.attachment}}
				</div>
			</div>
			<div class="h-[300px] mb-[30px] overflow-y-scroll">
				<div class="flex items-center justify-between mt-[20px]" v-for="(item,index) in filesList" :key="index">
					<div class="flex-1 flex items-center">
						<img src="@/static/image/icon66.png" class="w-[56px] h-[66px] mr-[17px]" alt="" />
						<div class="flex-1 yw-text-cut-1">
							{{item.name}}
						</div>
					</div>
					<div @click="downloadClick(item,index)"
						class="w-[140px] h-[40px] cursor-pointer leading-[40px] text-center text-[18px] text-[#ffffff] rounded-[4px] bg-[#FF0000] ">
						{{langInfo.download}}
					</div>
				</div>
			</div>
			<div class="h-[280px] bg-white rounded-[6px] px-[60px] py-[20px] box-border">
				<img src="@/static/image/icon67.png" class="w-[36px] h-[36px] mb-[20px]" alt="" srcset="" />
				<el-input type="textarea" class="mb-[20px]" :rows="5" resize="none" :placeholder="langInfo.comment_tip"
					v-model="textarea">
				</el-input>
				<div class="flex justify-end ">
					<div @click="submitBtn()"
						class="w-[97px] h-[36px] cursor-pointer leading-[36px] text-center text-[14px] text-[#ffffff] rounded-[4px] bg-[#2979FF] ">
						{{langInfo.published}}
					</div>
				</div>
			</div>
		</div>



		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'
	export default {
		components: {
			Header,
			Footer
		},
		data() {
			return {
				id: '',
				isFinish: false,
				newDetail: {
					title: '',
					content: '',
					create_time: '',
					number_likes: 0,
					number_views: 0,
					is_l2: 0,
					is_l1: 0
				},
				filesList: [],
				is_collect: 1,
				collectActive: require('@/static/image/icon65.png'),
				collectImg: require('@/static/image/icon64.png'),

				zanActive: require('@/static/image/icon71.png'),
				zanImg: require('@/static/image/icon70.png'),

				textarea: '',
				langInfo: {},

			}
		},
		watch: {
			'$route'(to, from) {
				// 当路由变化时，这里的to和from包含了路由信息
				if (to.query.id) {
					this.id = to.query.id
					this.get_resource_download()
				}
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.get_resource_download()
			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}
		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj

					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},

			goIndex() {
				this.$router.replace({ path: '/' });
			},
			goResourceDownload() {
				this.$router.replace({ path: '/resourceDownload' });
			},
			get_resource_download() {
				this.$api.resource_download({
					id: this.id
				}).then((res) => {
					console.log(res);
					this.isFinish = true
					this.newDetail = res.data
					document.title=res.data.title

					this.newDetail.content = res.data.content.replace(/<img/g,
						"<img style='width:100%;height:auto;'")

					this.filesList = res.data.files_attachment
				}).catch((error) => {
					this.isFinish = true
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 收藏
			newsResourceLikeClick(type) {
				
				if (!localStorage.getItem('token')) {
					this.$confirm(this.langInfo['please log in first'], this.langInfo['reg_tip'], {
						confirmButtonText: this.langInfo['Log in'],
						cancelButtonText: this.langInfo.cancel,
						type: 'warning'
					}).then(() => {
						this.$router.push({ path: '/login' })
					}).catch(() => {
						
					});
					return
				}
				
				
				
				this.$api.news_resource_like({
					fid: this.id,
					type: 2, //1=资讯,2=资源
					is_l: type //1=点赞,2=收藏
				}).then((res) => {
					console.log(res);
					this.$message({
						message: res.msg,
						type: 'success'
					})
					if (type == 2) {
						this.newDetail.is_l2 = this.newDetail.is_l2 == 1 ? 0 : 1
					} else if (type == 1) {
						this.newDetail.is_l1 = this.newDetail.is_l1 == 1 ? 0 : 1

						if (this.newDetail.is_l1 == 1) {
							this.newDetail.number_likes = Number(this.newDetail.number_likes) + 1
						} else {
							this.newDetail.number_likes = Number(this.newDetail.number_likes) - 1
						}
					}

				}).catch((error) => {

					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			downloadClick(item, index) {
				
				
				if (!localStorage.getItem('token')) {
					this.$confirm(this.langInfo['please log in first'], this.langInfo['reg_tip'], {
						confirmButtonText: this.langInfo['Log in'],
						cancelButtonText: this.langInfo.cancel,
						type: 'warning'
					}).then(() => {
						this.$router.push({ path: '/login' })
					}).catch(() => {
						
					});
					return
				}
				
				window.open('https://app.51exampass.comapi/v1.index/videoToStream?server=1&url=' + item.url, '_blank')

			},
			submitBtn() {
				if (!this.textarea) {
					this.$message({
						message: this.langInfo.comment_tip,
						type: 'warning'
					})
					return
				}

				this.$api.resource_comment({
					resource_download_id: this.id,
					content: this.textarea
				}).then((res) => {
					console.log(res);
					this.$message({
						message: res.msg,
						type: 'success'
					})
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 分享到qq
			shareQQ() {

				const url = encodeURIComponent(window.location.href);
				const title = encodeURIComponent(this.newDetail.title);
				const desc = encodeURIComponent(this.newDetail.title);
				const summary = encodeURIComponent(this.newDetail.title);
				const pics = encodeURIComponent('');

				window.open(
					`https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}&title=${title}&desc=${desc}&summary=${summary}&pics=${pics}`,
					'_blank');
			},
			// 分享到微博
			shareWB() {
				const url = encodeURIComponent(window.location.href);
				const title = encodeURIComponent(`${this.newDetail.title}`);
				window.open(`https://service.weibo.com/share/share.php?url=${url}&title=${title}`, '_blank');
			},

			// 分享微信
			shareWx() {
				const url = window.location.href;
				const textArea = document.createElement('textarea');
				textArea.value = url;
				textArea.style.position = 'fixed'; // 避免可见区域闪烁
				document.body.appendChild(textArea);
				textArea.select();
				// 尝试复制并处理可能的异常
				const success = document.execCommand('copy');
				document.body.removeChild(textArea);
				if (success) {
					// this.statusMessage = "已成功复制到剪贴板！"; //（兼容模式）
					// this.$message.success(this.statusMessage);
					this.$message.success(this.langInfo['Successfully copied to clipboard']);

				} else {
					this.$message.success("复制方法失败");
				}
			}
		}
	}
</script>

<style scoped>
	.banner {
		height: 263px;
		background: linear-gradient(180deg, rgba(110, 175, 247, 1) 0%, rgba(112, 176, 247, 0.64) 0%, rgba(120, 179, 248, 0.11) 34%, rgba(255, 255, 255, 0.11) 100%);
	}

	.navTitle.active::after {
		content: "";
		position: absolute;
		width: 30px;
		height: 4px;
		background-color: #FF0000;
		bottom: -16px;
		left: 50%;
		transform: translateX(-50%);

	}

	::-webkit-scrollbar {
		display: none;
	}

	/deep/.el-textarea__inner {
		background-color: #F2F3F6;
	}
</style>